export default (state = {}, action) => {
  let { type, payload } = action
  switch (type) {
  case 'TERMS_SET':
    return payload
  default:
    return state
  }
}
